export default [
  {
    path: "/preciosHora",
    component: () => import("@/views/preciosHora/Listar.vue"),
  },
];
